import { ReactNode, useState } from 'react';

export interface ModalData {
    key? : string;
    title: string;
    content: ReactNode;
}

export interface ModalHook {
    modalData: ModalData | null,
    openModal: (data: ModalData) => void,
    closeModal: () => void
}

export function useModal() : ModalHook {
    const [modalData, setModalData] = useState<ModalData | null>(null);

    const openModal = (data: ModalData) => setModalData(data);
    const closeModal = () => {
        setModalData(null);
    };

    return {
        modalData,
        openModal,
        closeModal
    };
}
